import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import React from "react";

const AuthUserContext = React.createContext<firebase.User | null | undefined>(
  undefined,
);

export default AuthUserContext;
